<template>
    <div>
        <div @click='toggleMobileMenu'><i class="fa-regular fa-bars hamburger"></i></div>
        <div class="mobile-menu">
            <div class='mobile-menu-content'>
                <div class='close-mobile-menu-container'>
                    <Logo/>
                    <div @click='toggleMobileMenu'><div class="fa-regular fa-xmark close-mobile-menu"></div></div>
                </div>
                <div class='mobile-item-headings'>
                    <div v-for='heading in headings' class='heading-container' :key="heading.id">
                        <div @click='selectedHeader(heading)'>
                            {{heading.name}}
                        </div>
                        <div v-show='heading.sub_headings.length != 0' class='icon-container' @click='openSubMenu(heading)'>
                            <i class="fa-solid fa-angle-right right-arrow"></i>
                        </div>
                    </div>
                    <MobileSubMenu :open_sub_menu='open_sub_menu_watcher' :selected_heading='selected_heading' @selectedMenuItemListener='selectedMenuItem'/>
                </div>
                    <div class='mobile-button-container'>
                        <button class='header-button login' @click='headerClick("login")'><i class="fa-regular fa-cart-shopping header-button-icon"></i> Login & Order</button>
                        <button class='header-button'  @click='headerClick("new_customer")'><i class="fa-regular fa-arrow-right header-button-icon"></i>New Customer</button>
                    </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import MobileSubMenu from '@/ecom/components/navigation/header/menus/MobileSubMenu.vue';
import Logo from '@/ecom/components/navigation/header/Logo.vue';

export default {
    components:{MobileSubMenu, Logo},
    props: ['menu_items', 'headings', 'sub_headings'],
    data(){
        return{
            open_sub_menu_watcher: null,
            selected_heading: []
        }
    },
    methods:{
        toggleMobileMenu(){
            const mobile_menu = document.querySelector('.mobile-menu');
            mobile_menu.classList.toggle('is-open');
        },
        selectedHeader(header){
            if(header.sub_headings.length == 0){
                this.selectedMenuItem(null, header);
            }
            else{
                this.openSubMenu(header);
            }
        },
        selectedMenuItem(e, category){
            this.toggleMobileMenu();
            let url = (category.type == 'CU') ? category.custom_url : `/${category.sef_url}`;
            this.$router.push(url);
        },
        openSubMenu(heading){
            this.selected_heading = this.menu_items.filter(x=>x.id == heading.id)[0];
            this.open_sub_menu_watcher = +new Date();
        },
        headerClick(type){
            if(type == 'login'){
                window.location.href = "https://commercialonlineorders.majestic.co.uk/";
            }
            if(type == 'new_customer'){
                this.$router.push('/how-does-it-work/new-customer');
                this.toggleMobileMenu();
            }
        }
    }
}
</script>
<style lang="scss" scoped>

.hamburger{
    display: none;
    font-size: 1.2rem;
    margin-left: 24px;

    @media(max-width: 1100px){
        display: block;
    }
}

.mobile-menu {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100dvh;
	z-index: 100;
    background-color: #FFF;
	color: black;
	transform: translateY(-100%);
	transition: 0.3s;
    transition: transform 330ms ease-in-out;
    overflow-y: hidden;
    overflow-x: hidden;
}

.mobile-menu.is-open {
	transform: translateY(0);
    transition: 0.7s;
    transition: transform 330ms ease-in-out;
}

.mobile-menu-content{
    padding: 20px;
}

.close-mobile-menu-container{
    display: flex;
    justify-content: space-between
}
.close-mobile-menu{
    font-size: 2.5rem;
}

.mobile-item-headings{
    font-size: 1.1rem;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 30px;
    position: relative;
}

.heading-container{
    display: flex;
    align-items: center;
    // justify-content: space-between;
}

.right-arrow{
    color: var(--primary-colour-2);
    float: right;
}
.icon-container{
    flex-grow: 1;
}

.mobile-button-container{
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 48px;
}

.header-button{
    padding: 12px;
    border-radius: 8px;
    background-color: white;
    border: 1px solid gray;
    outline: none;
    cursor: pointer;
}

.header-button.login{
    background-color: #184A2E;
    color: white;

}
.header-button-icon{
    margin-right: 4px;
}
</style>